import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import DefaultEstatePlanningAttorneys from './DefaultEstatePlanningAttorneys';

const EstatePlanningAttorneysPicker = (props) => {
  const { householdResource } = useSimpleHousehold();

  return pickFunction(householdResource, {
    [fr.relationships.default.name]: () => {
      return (
        <DefaultEstatePlanningAttorneys {...props} />
      );
    },
  });
};

export default EstatePlanningAttorneysPicker;
